export enum CourseActiveTabs {
    coursePlan = 'coursePlan',
    basicInfo = 'basicInfo',
    advancedSettings = 'advancedSettings'
}